import numeral from 'numeral/min/numeral.min.js';
// validated: esbuild
globalThis.numeral = numeral;